import React from "react";
import { ComponentsBaseProps } from "../../../../types";
import { VehicleDetails1 } from "../details-1";
import { ContactActionButtonType, ContactActionType } from "../details-1/props";

export interface InventoryResolverProps extends ComponentsBaseProps {
  [key: string]: any;
}

//@ts-ignore
export const InventoryResolverMock: InventoryResolverProps = {
  id: "InventoryResolver",
  componentName: "InventoryResolver",
  position: 0,
  isSortable: false,
  isDeletable: false,
  isEditable: false,
  isSmartComponent: false,
  label: "Estoque",
  Filter1: {
    id: "Filter1",
    position: 1,
    componentName: "Filter1",
    data: {
      vehicleList: [],
      shouldRenderDetail: true,
    },
  },
  VehicleDetails1: {
    id: "VehicleDetails1",
    position: 0,
    componentName: "VehicleDetails1",
    shouldRenderDetail: true,
    showPrice: true,
    contactActions: [
      {
        actionType: ContactActionType.whatsApp,
        buttonType: ContactActionButtonType.default,
        required: true,
        label: "Chamar no WhatsApp",
        placeholder: "11 99999-9999",
        receiver: "", //precisariamos do editor funcional p/ essa prop
        link: "",
        regex: "", //setar
      },
      {
        actionType: ContactActionType.cellphone,
        buttonType: ContactActionButtonType.default,
        required: false,
        label: "Ligar Agora Mesmo",
        placeholder: "11 99999-9999",
        receiver: "", //precisariamos do editor funcional p/ essa prop
        link: "",
        regex: "", //setar
      },
      {
        actionType: ContactActionType.whatsApp,
        buttonType: ContactActionButtonType.pulsing,
        required: false,
        label: "Chamar no WhatsApp",
        placeholder: "11 99999-9999",
        receiver: "", //precisariamos do editor funcional p/ essa prop
        link: "",
        regex: "", //setar
      },
    ],
    data: {
      vehicle: {},
      vehicleList: [],
      shouldRenderDetail: true,
    },
  },
};

export function InventoryResolver(props: InventoryResolverProps) {
  const propsList = Object.values(props);
  if (
    propsList.find((i) => i.name == "VehicleInventory1")?.data
      ?.shouldRenderDetail
  ) {
    const detailsProps: any = propsList.find(
      (g) => g.componentName === "VehicleDetails1"
    ) as any;
    return <VehicleDetails1 {...detailsProps} />;
  } else {
    return <div />;
  }
}
